import heroMedical from '../assets/imgs/inicio/1.webp';
import heroHorrors from '../assets/imgs/inicio/2.webp';
import heroTraffic from '../assets/imgs/inicio/3.webp';
import heroContract from '../assets/imgs/inicio/4.webp';
import specialtyMedical from '../assets/imgs/inicio/5.webp';
import specialtyAdministration from '../assets/imgs/inicio/6.webp';
import specialtyProperty from '../assets/imgs/inicio/7.webp';
import specialtyNegotiation from '../assets/imgs/inicio/8.webp';
import specialtyAdministracion from '../assets/imgs/inicio/9.webp';
import specialtyInmobiliaria from '../assets/imgs/inicio/10.webp';
import specialtyConciliacion from '../assets/imgs/inicio/11.webp';
import heroAbout from '../assets/imgs/sobre-nosotros/1.webp';
import heroWhy from '../assets/imgs/porque-elegirnos/1.webp';
import heroContact from '../assets/imgs/contacto/1.webp';
import building from '../assets/imgs/sobre-nosotros/2.webp';
import aldo from '../assets/imgs/sobre-nosotros/3.webp';
import type { IconName } from '../components/Icon';
import aliado1 from '../assets/imgs/Logo_ipc.webp';

export const BRAND = {
  burgundy: '#63011F',
  burgundyDark: '#471224',
  cream: '#F8F0E7',
  gold: '#C89136',
} as const;

export const CONTACT = {
  phoneDisplay: '+51 959 105 505',
  phoneInternational: '51959105505',
  phoneLink: 'https://wa.me/51959105505',
  email: 'Pca.abogados@gmail.com',
  website: 'https://www.indemniza.pe/',
  address: 'Av. Circunvalación El Golf los Incas 134, Torre 2 Piso 6, Santiago de Surco, Lima',
  shortAddress: 'Av. Circunvalación El Golf los Incas 134, Torre 2 Piso 6, Santiago de Surco',
  hours: 'Lun a Vie: 9:00 a.m. - 6:00 p.m.',
  mapEmbedUrl:
    'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d31211.40510124807!2d-76.98925859375696!3d-12.082986899167858!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x9105c7ab4a669861%3A0x46a4f8e1c41a1685!2sPanorama%20Centro%20Empresarial!5e0!3m2!1ses-419!2spe!4v1770931332727!5m2!1ses-419!2spe',
} as const;

export const NAV_ITEMS = [
  { label: 'Inicio', to: '/' },
  { label: 'Sobre Nosotros', to: '/sobre-nosotros' },
  { label: 'Por qué elegir Indemniza', to: '/por-que-elegirnos' },
  { label: 'Cómo contactarnos', to: '/contacto' },
] as const;

export type HeroSlide = {
  id: string;
  image: string;
  eyebrow?: string;
  title?: string;
  subtitle?: string;
  accent?: string;
  showSocials?: boolean;
  objectPosition?: string;
  mobilePosition?: string;
};

export const HOME_HERO_SLIDES: readonly HeroSlide[] = [
  {
    id: 'negligencias',
    image: heroMedical,
    objectPosition: 'center',
    mobilePosition: '18% center',
  },
  {
    id: 'horrores',
    image: heroHorrors,
    objectPosition: 'center',
    mobilePosition: '50% center',
  },
  {
    id: 'transito',
    image: heroTraffic,
    objectPosition: 'center',
    mobilePosition: '18% center',
  },
  {
    id: 'contratos',
    image: heroContract,
    objectPosition: 'center',
    mobilePosition: '18% center',
  },
];

export const TRUST_ITEMS: readonly { icon: IconName; title: string; description: string }[] = [
  { icon: 'bolt', title: 'Estrategias ágiles y preventivas', description: 'Resolución ágil de controversias' },
  { icon: 'hourglass', title: '+25 años de experiencia', description: 'En materia indemnizatoria' },
  { icon: 'scale', title: 'Especialización en indemnizaciones', description: 'Defensa técnica en daños y perjuicios' },
  { icon: 'document', title: 'Equipo técnico pericial', description: 'Peritajes y sustento probatorio especializado' },
];

export type ServiceItem = {
  image: string;
  title: string;
  description: string;
};

export const SERVICES: readonly ServiceItem[] = [
  {
    image: specialtyMedical,
    title: 'Negligencias médicas',
    description: 'Defendemos a víctimas de mala praxis médica y errores clínicos con evidencia técnica sólida.',
  },
  {
    image: specialtyAdministration,
    title: 'Accidentes de tránsito con lesiones o fallecimiento',
    description: 'Recuperamos la compensación que corresponde por daños físicos, materiales y morales tras un accidente.',
  },
  {
    image: specialtyProperty,
    title: 'Cobranzas y prácticas abusivas de bancos o empresas de inversión',
    description: 'Cobranza bancaria abusiva y problemas de inversiones. Recuperamos lo que te corresponde.',
  },
  {
    image: specialtyNegotiation,
    title: 'Incumplimiento de todo tipo de contrato',
    description: 'Reclamo y compensación cuando la otra parte no cumple con lo pactado en cualquier tipo de contrato.',
  },
  {
    image: specialtyAdministracion,
    title: 'Empresas de administración de edificios e inmobiliarias',
    description: 'Cuando la administración no cumple con los servicios prometidos a los propietarios.',
  },
  {
    image: specialtyInmobiliaria,
    title: 'Incumplimientos ante compras inmobiliarias de todo tipo',
    description: 'Infórmate y asesórate antes de firmar la compra de una propiedad. Cuenta con profesionales adecuados para todas las verificaciones.',
  },
  {
    image: specialtyConciliacion,
    title: 'Negociaciones y conciliación',
    description: 'Solución rápida y ágil a tu problema mediante negociación estratégica sin necesidad de juicio.',
  },
];

export const GUARANTEES: readonly { icon: IconName; top: string; bottom: string }[] = [
  { icon: 'bolt', top: 'Estrategias ágiles y preventivas', bottom: 'Resolución ágil de controversias' },
  { icon: 'hourglass', top: 'Más de 25 años de experiencia', bottom: 'En materia indemnizatoria' },
  { icon: 'scale', top: 'Especialización en indemnizaciones', bottom: 'Defensa técnica en daños y perjuicios' },
  { icon: 'document', top: 'Equipo técnico pericial', bottom: 'Peritajes y sustento probatorio' },
];

export const ABOUT = {
  heroImage: heroAbout,
  heroPosition: '50% 48%',
  heroMobilePosition: '50% 50%',
  building,
  aldo,
  story: {
    eyebrow: 'Nuestra historia',
    title: 'Autoridad, solidez y resultados',
    paragraphs: [
      'Corporación Indemniza es una firma legal de alto nivel, especializada en la defensa y recuperación de derechos vulnerados. Nuestra identidad se construye sobre los pilares de la autoridad jurídica, la solidez y la excelencia.',
      'No somos un intermediario ni una aseguradora; intervenimos legalmente para restaurar el equilibrio y buscar que nuestros clientes reciban la reparación y compensación que correspondan conforme a ley.',
    ],
  },
} as const;

export const VALUES: readonly { icon: IconName; title: string; description: string }[] = [
  { icon: 'scale', title: 'Autoridad jurídica', description: 'Conocimiento técnico profundo y defensa firme en cada proceso.' },
  { icon: 'eye', title: 'Transparencia', description: 'Comunicación clara y honesta en cada etapa de tu caso.' },
  { icon: 'shield', title: 'Compromiso', description: 'Luchamos incansablemente con todo el peso de la ley.' },
  { icon: 'star', title: 'Excelencia', description: 'Estándares de alto nivel en cada resultado que entregamos.' },
];

export const TEAM = [
  { image: aldo, name: 'Aldo Polack Cavassa', role: 'Socio Fundador', area: 'Indemnizaciones y Daños' },
  //{ image: aldo, name: 'Nombre Apellido', role: 'Asociada Senior', area: 'Negligencia Médica' },
  //{ image: aldo, name: 'Nombre Apellido', role: 'Asociado', area: 'Derecho Bancario' },
] as const;

export const PARTNERS = [
  {
    name: 'IPC',
    image: aliado1,
  },
] as const;

export const WHY = {
  heroImage: heroWhy,
  heroPosition: '50% 48%',
  heroMobilePosition: '56% 50%',
  reasons: [
    { icon: 'document' as IconName, title: 'Especialización exclusiva', description: 'No somos un estudio generalista. Nos dedicamos únicamente a indemnizaciones y reparación de daños.' },
    { icon: 'hourglass' as IconName, title: '+25 años de experiencia', description: 'Trayectoria comprobada en materia indemnizatoria, con conocimiento profundo de cada proceso.' },
    { icon: 'bolt' as IconName, title: 'Estrategias ágiles', description: 'Resolución rápida de controversias, priorizando la negociación estratégica cuando es posible.' },
    { icon: 'shield' as IconName, title: 'Equipo técnico pericial', description: 'Peritajes propios que sustentan cada reclamo con evidencia técnica sólida, no solo argumentos legales.' },
    { icon: 'eye' as IconName, title: 'Transparencia total', description: 'Sabrás en todo momento en qué etapa está tu caso y qué puedes esperar, sin letra pequeña.' },
    { icon: 'heart' as IconName, title: 'Compromiso real', description: 'Luchamos con todo el peso de la ley para buscar la reparación y compensación que correspondan según cada caso.' },
  ],
  comparison: [
    { withUs: 'Evaluación técnica-legal profesional de tu caso', withoutUs: 'Desconocimiento de tus derechos reales' },
    { withUs: 'Estrategia de negociación experta', withoutUs: 'Riesgo de aceptar la primera oferta, casi siempre baja' },
    { withUs: 'Peritajes propios que sustentan el reclamo', withoutUs: 'Sin evidencia técnica sólida' },
    { withUs: 'Seguimiento constante de cada etapa del caso', withoutUs: 'Procesos que se estancan o abandonan' },
  ],
} as const;

export const CONTACT_PAGE = {
  heroImage: heroContact,
  heroPosition: '50% 48%',
  heroMobilePosition: '58% 52%',
  caseTypes: [
    'Negligencias médicas',
    'Accidentes de tránsito',
    'Cobranzas y prácticas abusivas',
    'Incumplimiento de contrato',
    'Administración de edificios',
    'Compras inmobiliarias',
    'Negociación y conciliación',
  ],
} as const;

export const SOCIALS = {
  instagram: 'https://www.instagram.com/indemniza.pe/',
  facebook: 'https://www.facebook.com/people/indemnizape/61574120930801/',
  tiktok: 'https://www.tiktok.com/@indemniza.pe',
} as const;

export function buildWhatsAppUrl(message?: string): string {
  const text = message?.trim() || 'Buen día, me comunico para solicitar información y orientación.';
  return `https://wa.me/${CONTACT.phoneInternational}?text=${encodeURIComponent(text)}`;
}
